<template>
  <div id="app">
  <Header :key="$route.fullPath" v-if="!$route.path.includes('/admin')"/>

  <div class="screen-container">  
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>

  <div class="nav-drawer" :class="{'nav-drawer-active': activeNav}">
    <div v-if="loggedIn" @click="addActive" class="nav-button">
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
    </div>
      <!-- <ul>
      <li><router-link to="/dashboard">Dashboard</router-link></li>
      <li><router-link to="/patients">Patients</router-link></li>
      <li><router-link to="/messages">Messages</router-link></li>
      <li><router-link to="/appointment">Schedule</router-link></li>

    </ul> -->
    <Dashboard/>
  </div>

  </div>

</template>
<script>

import Header from './components/Header.vue'
import { firestore, auth, database } from "./main";
import { mapMutations, mapGetters } from 'vuex'
import Dashboard from './components/Dashboard.vue'


export default {
  name: 'app',
  data () {
    return {
      headerColor: "rgba(0, 0, 0, 0.2)",
      activePage: 'LuciDent'
    }
  },
  watch: {
    $route (to, from){
      this.$store.state.activeNav = false
    }
  },
  components: {
    Header,
    Dashboard
  },
  methods: {
    setUser: function() {
      this.$store.dispatch("setUser");
    },
    addActive() {
      this.$store.dispatch("addActive")
    },
  },
  beforeCreate() {
    this.$store.dispatch('fetchCreds');
  },
  computed: {
    getState() {
      return this.$store.state;
    },
    ...mapGetters([
      'loggedIn',
      'user',
      'isLoading',
      'activeNav'
    ]),
    user() {
      return this.$store.getters.getUser;
    },
    options() {
      return this.$store.state.options;
    }
  }
}

</script>

<style lang="scss">

  $break-small: 900px;
  $brandColor: #29aad0;
  $brandColorTwo: #70c8df;
  $accentColor: #de7c5e;

  @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro');
  @import url('https://fonts.googleapis.com/css?family=Roboto+Slab&display=swap');

a {
  font-style: unset;
  color: unset;
}
::selection {
  background: rgb(239, 239, 239); /* WebKit/Blink Browsers */
  color: #fff;
}
::-moz-selection {
  background: rgb(239, 239, 239); /* Gecko Browsers */
  color: #fff;
}
    .treatment {
      background-color: #B5F5E6;
    }
    .messages {
      background-color: #FFEEBC;
    }
    .escripts {
      background-color: #D7D4FF;
    }
    .patient {
      background-color: #FFCFBF;
    }
    .insurance {
      background-color: #FFCFBF;
    }
    .office {
      background-color: #E8EDED;
    }
.nav-drawer {
  background-color: #fcfcfc;
  width: 50vh;
  height: 50vh;
  position: fixed;
  z-index: 999999;
  left: -50vh;
  top: -50vh;
  border-radius: 50%;
  transition: all .75s ease-in-out;
  overflow: hidden;
  
  ul  {
    position: absolute;
    top: 50vh;
    left: 50vh;
    width: 90vw;
    height: 90vh;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    li {
      margin: 1em auto;
      font-size: 7vw;
      padding-bottom: 5px;
      color: #232535;
      border-bottom: 1px solid #232535;
      a {
        text-decoration: none;
      }
    }
  }
}
.nav-drawer-active {
  width: 200vh;
  height: 200vh;
}
.nav-button {
  position: fixed;
  top: 0;
  left: 0;
  width: 80px;
  height: 80px;
  z-index: 99999999;
  text-align: center;
  overflow: visible;
  background-color: #fcfcfc;
  display: flex;
  padding-top: 20px;
  flex-direction: column;
  border-bottom-right-radius: 20px;

}
.nav-button .line {
  width: 40%;
  height: 4px;
  background-color: #232535;
  margin: 4px 7px 4px 10px;
  border-radius: 20px;
  position: relative;
  overflow: visible;
  visibility: visible;

  &::after {
    content: "";
    position: absolute;
    width: 12px;
    height: 4px;
    right: -18px;
    border-radius: 20px;
    background-color: #232535
  }
}
html {
    overflow: scroll;
    overflow-x: hidden;
}
::-webkit-scrollbar {
    width: 0px;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
    background: #FF0000;
}
.screen-container {
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    position: relative;
    background-color: #232535;
    top: 100px;
    width: 100%;
    height: auto;
    padding: 0;
    border-top-right-radius: 30px;
    border-top-left-radius: 30px;
    z-index: 2;
}
.message {
  padding: 2em 0;
}
.page-title {
  color: $brandColor;
  font-size: 24px;
  text-transform: uppercase;
  // height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

html,body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  // background-color: rgb(242, 248, 255);
  background-color: #fff;
}
body {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 50%;
    left: 0;
    bottom: 0;
    background-color: #232535;
    z-index: 1;
  }
}

.button {
  padding: 10px 20px;
  color: #fff;
  background-color: #de7c5e;
  margin: 2px;
}

.dot {
  // background-color: #ddd;
      animation: shadow-pulse 2s infinite;
      position: absolute;
      background-color: #fff;;
      bottom: 20px;
      left: 20px;
      width: 6vh;
      height: 4vh;
      font-size: 2vh;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      cursor: pointer;
      z-index: 9999;
}
.bg-1,.bg-2,.bg-3,.bg-4,.bg-5,.bg-6,.bg-7,.bg-8,.bg-9,.bg-10,.bg-11,.bg-12,.bg-13,.bg-14,.bg-15,.bg-16 {
  background-color: #ddd;
}
.bg-1 {
  background-color: $brandColor;
}
.bg-2 {
  background-color: $accentColor;
}
.bg-3 {
  background-color: $brandColorTwo;
}
.bg-4 {
  background-color: #B5F5E6;
}



#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #222;
  margin-top: 0;
  width: 100%;
  text-align: center;

}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.1s;
  transition-property: opacity;
  transition-timing-function: ease-in-out;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

@keyframes animate {
  0% {
    width: 100%;
  }
  50% {
    width: 50%;
  }
  100% {
    width: 100%;
  }
}
  .hide-desktop {
    display: none !important;

  }
  .hide-mobile {
    display: block;
  }

@media only screen and (max-width: 900px) {
  .info {
    width: 90%;
    max-width: 90%;
    margin: 0 auto;
  }
  .info p {
    max-width: 100%;
  }
  .hide-desktop {
    display: block !important;
  }
  .hide-mobile {
    display: none !important;
  }
}


</style>

  





// WEBPACK FOOTER //
// src/App.vue